import { Component } from '@angular/core';

@Component({
  selector: 'ag-widget-layout',
  templateUrl: './widget-layout.component.html',
  styleUrls: ['./widget-layout.component.scss'],
})
export class WidgetLayoutComponent {
  constructor() {}
}
